import React from 'react';
import classNames from 'classnames';
import {
  FieldError,
  FieldValues,
  UseFormMethods,
  RegisterOptions,
} from 'react-hook-form';
import { get } from 'lodash';
import warningImage from '../../../assets/warning.png';
import { getValidationErrorMessage } from '../../../utils/validation';
// eslint-disable-next-line import/named
import { FlattenKeys } from '../../../types/utilTypes';
import styles from './styles.module.scss';

type Props<T extends FieldValues> = {
  className?: string;
  variant?: 'default' | 'vertical';
  label: string;
  title?: string;
} & (
  | {
      // name is required when form is set
      name: FlattenKeys<T>;
      form: UseFormMethods<T>;
      validation?: RegisterOptions;
      // the form should control the component when it's set
      value?: undefined;
      onChange?: undefined;
    }
  | {
      name?: string;
      form?: undefined;
      // validation requires a form to be provided
      validation?: undefined;
      value?: boolean;
      onChange?: (value: boolean) => void;
    }
);

export const Checkbox = <T extends FieldValues>({
  className,
  variant,
  label,
  name,
  form,
  validation,
  value,
  onChange,
  title,
}: Props<T>) => {
  const validationError = get(form?.errors, name as string) as
    | FieldError
    | undefined;
  return (
    <div className={className}>
      {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
      <label
        className={classNames(
          styles.container,
          !!validationError && styles.invalid,
          variant === 'vertical' && styles.vertical,
        )}
      >
        {label}
        <input
          ref={form?.register(validation)}
          className={styles.input}
          name={name as string}
          type="checkbox"
          title={title}
          checked={value}
          onChange={() => onChange?.(!value)}
        />
        <span className={styles.checkmark} />

        {!!validationError && (
          <>
            <div className={styles.warningIcon}>
              <img src={warningImage} alt="Warning" />
            </div>
            <span className={styles.warningText}>
              {getValidationErrorMessage(validationError)}
            </span>
          </>
        )}
      </label>
    </div>
  );
};
